import MainSec from "./components/MainSection/MainSec";

function App() {
  return (
    <>
      <MainSec />
    </>
  );
}

export default App;
